import { useObserver } from 'mobx-react';
import viewStore from '../stores/ViewStore';

export const useTableView = () => {
  const setTableView = (value) => {
    viewStore.setTableView(value);
  };

  const setViewMode = (mode) => {
    viewStore.setViewMode(mode);
  };

  return useObserver(() => ({
    isTableView: viewStore.getIsTableView,
    isAdvancedTable: viewStore.isAdvancedTable,
    isGrid: viewStore.isGrid,
    viewMode: viewStore.getViewMode,
    setTableView,
    setViewMode,
  }));
};